import { useEffect, useRef, useState } from 'react';

export interface CompositionRow {
  label: string;
  value: number;
}

interface Props {
  rows: CompositionRow[];
}

/** Renders a small "signal → overall score" flow with lazily-loaded mermaid. */
export default function ScoreCompositionDiagram({ rows }: Props) {
  const ref = useRef<HTMLDivElement>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
    let cancelled = false;
    const graph =
      'graph LR\n' +
      rows
        .map((r, i) => `  S${i}["${r.label} (${Math.round(r.value)})"] --> O`)
        .join('\n') +
      '\n  O(["Overall score"])';

    (async () => {
      try {
        const mermaid = (await import('mermaid')).default;
        mermaid.initialize({
          startOnLoad: false,
          theme: 'base',
          themeVariables: { fontSize: '13px' },
        });
        const { svg } = await mermaid.render(
          'score-composition-' + rows.length,
          graph,
        );
        if (!cancelled && ref.current) ref.current.innerHTML = svg;
      } catch {
        if (!cancelled) setFailed(true);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [rows]);

  if (failed) return null; // radar already conveys composition; diagram is additive
  return <div className="POST__ANALYSIS__mermaid" ref={ref} />;
}
